import { createSlice } from "@reduxjs/toolkit";

const carePlanSlice = createSlice({
    name: "carePlans",
    initialState: {},
    reducers: {
        registerCarePlan: (state, action) => {
            const plan = action.payload;
            if (!plan?.id) return;

            if (!state[plan.id]) {
                state[plan.id] = plan;
            } else {
                console.warn(
                    `⚠️ CarePlan ${plan.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterCarePlans: (state, action) => {
            action.payload.forEach((plan) => {
                if (!plan?.id) return;

                if (!state[plan.id]) {
                    state[plan.id] = plan;
                } else {
                    console.warn(
                        `⚠️ CarePlan ${plan.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const { registerCarePlan, bulkRegisterCarePlans } = carePlanSlice.actions;
export default carePlanSlice.reducer;
